import TenantVerificationBanner from "../TenantVerificationBanner";
import GetMeta from "@pages/SeoPages/GetMeta";
import { DashboardSideBar } from "@shared/navbars";
import { DashboardHeader } from "./DashboardHeader";
import { ToastContainer } from "react-toastify";
import { useSessionStorage } from "../../hooks/";
import {
  getUnreadUserNotifications,
  getUserNotifications,
  markReadNotification,
} from "@services/krent.service";
import { useEffect, useState } from "react";
import { NotificationsInterfaceResponse } from "@interfaces/notifications.interface";
import { BaseApiResponse } from "@interfaces/app.interface";
import { useNavigate } from "react-router-dom";

type Props = {
  children?: JSX.Element | JSX.Element[];
  title?: string;
  subtitle?: string;
};

export const DashboardLayout: React.FC<Props> = ({
  children,
  title,
  subtitle,
}: Props) => {
  const [user] = useSessionStorage("user", {});
  const [notifications, setNotifications] = useState<
    NotificationsInterfaceResponse[]
  >([]);
  const [notificationsCount, setNotificationsCount] = useState(0);
  const [showMobileSidebar, setShowMobileSidebar] = useState(false);
  const navigate = useNavigate();

  const handleGetNotifications = () => {
    let abortController = new AbortController();

    getUserNotifications(user?._id, abortController.signal)
      .then((res: BaseApiResponse<NotificationsInterfaceResponse[]>) => {
        setNotifications(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
    getUnreadUserNotifications(user?._id, abortController.signal)
      .then((res: any) => {
        setNotificationsCount(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleMarkReadNotification = (id: string, _type: string) => {
    let abortController = new AbortController();
    markReadNotification(id, abortController.signal)
      .then(() => {
        getUserNotifications(user?._id, abortController.signal)
          .then((res: BaseApiResponse<NotificationsInterfaceResponse[]>) => {
            setNotifications(res.data);
          })
          .catch((err) => {
            console.log(err);
          });
        if (
          user.role === "agent" ||
          user.role === "landlord" ||
          user.role === "property-manager"
        ) {
          navigate("/requests");
        }
        getUnreadUserNotifications(user?._id, abortController.signal)
          .then((res: any) => {
            setNotificationsCount(res.data);
          })
          .catch((err) => {
            console.log(err);
          });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    handleGetNotifications();
  }, [user]);

  return (
    <div className="container-fluid">
      <ToastContainer limit={1} />

      <GetMeta description="Krent is a real estate and property listing website in Nigeria. Find homes to buy or rent from trusted landlords and agents. Sell your property or find a new home easily with our wide selection of flats, apartments, houses, and more" />
      {/* <div className='row'> */}
      <div className="row vh-100">
        <DashboardSideBar
          showMobileSidebar={showMobileSidebar}
          setShowMobileSidebar={setShowMobileSidebar}
        />

        <div className="col-12 col-md-12 col-lg-9 col-xl-10 bg-white px-0 ms-sm-auto position-relative ">
          <DashboardHeader
            notificationsCount={notificationsCount}
            title={title}
            subtitle={subtitle}
            showMobileSidebar={showMobileSidebar}
            setShowMobileSidebar={setShowMobileSidebar}
          />
          <div className="py-3 text-center bg-opacity-10 notification-bar">
            <p className="mb-0 fs-14 fw-600"></p>
          </div>
          <div className="pb-2 px-md-3 col-12 col-md-12 bg-white px-0 ms-sm-auto position-relative ">
            <div className="container mt-3 mt-md-4">
              {user.role === "user" && (
                <TenantVerificationBanner userId={user?.id || user?._id} />
              )}
              {children}
            </div>
          </div>
        </div>
      </div>

      <div
        className="offcanvas offcanvas-start"
        id="sidebarOffcanvasActivity"
        tabIndex={-1}
        data-bs-scroll="true"
        data-bs-backdrop="false"
        style={{ zIndex: "999999 !important" }}
      >
        <div className="offcanvas-header">
          <h4 className="offcanvas-title text-black">Notifications</h4>
          <button
            type="button"
            className="btn-close text-danger cursor-pointer"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          ></button>
        </div>
        <div className="offcanvas-body" style={{ zIndex: "999999 !important" }}>
          <div className="list-group list-group-flush list-group-activity my-n3">
            {notifications?.map((notification: any) => (
              <span
                key={notification.id}
                className={`list-group-item text-reset cursor-pointer ${
                  !notification.read ? "bg-primary mt-1" : ""
                }`}
                onClick={() =>
                  handleMarkReadNotification(notification.id, notification.type)
                }
              >
                <div className="row">
                  <div className="col-auto">
                    <div className="avatar avatar-sm">
                      <div className="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                        <i className={`fa ${notification.icon}`}></i>
                      </div>
                    </div>
                  </div>
                  <div
                    className={`col ms-n2  ${
                      !notification.read ? "text-white" : "text-gray"
                    }`}
                  >
                    <h5 className="mb-1 break-words">{notification.title}</h5>
                    <p
                      className={`small ${
                        !notification.read ? "text-white" : "text-gray-700"
                      } mb-0`}
                    >
                      {notification.message}
                    </p>
                    <small className=" fw-bolder">
                      {" "}
                      {new Date(
                        notification.createdAt.toLocaleString(),
                      ).toLocaleDateString("en-US", {
                        year: "numeric",
                        month: "short",
                        day: "numeric",
                      })}
                    </small>
                  </div>
                </div>
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
